package com.solevo.dist.repository.implementation.notification

import com.solevo.dist.application.models.ChangeStatusRequest
import com.solevo.dist.application.models.Notification
import com.solevo.dist.application.models.NotificationType
import com.solevo.dist.network.api.notifications.NotificationRemoteSource
import com.solevo.dist.repository.ApplicationNotificationRepository
import kotlinx.coroutines.flow.Flow

class NotificationRepository(
    private val notificationRemoteSource: NotificationRemoteSource
): ApplicationNotificationRepository {
    override fun getNotifications(limit: Int, type: NotificationType?): Flow<List<Notification>> {
        return notificationRemoteSource.getNotificationsLive(limit, type)
    }

    override fun checkUnreadMessages(): Flow<Boolean> {
        return notificationRemoteSource.checkUnreadNotifications()
    }

    override fun getNotificationDetails(notificationId: String): Flow<Notification?> {
        return notificationRemoteSource.getNotification(notificationId)
    }

    override suspend fun changeNotificationStatus(changeStatusRequest: ChangeStatusRequest) {
        notificationRemoteSource.updateNotification(
            changeStatusRequest.notificationKey?.notificationId ?: "",
            mapOf("status" to (changeStatusRequest.newStatus))
        )
    }
}
